import { MenuItem } from '@mui/material'
import { updateDeliveryDateStore } from 'modules/orders/components/updateDeliveryDate'
import UpdateDeliveryDateModal from 'modules/orders/components/updateDeliveryDate/updateDeliveryDate'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'

import { ActionsItemProps } from './actions'

export const UpdateDeliveryDate = ({ order, disabled }: ActionsItemProps) => {
  const isModalOpen = updateDeliveryDateStore.useIsModalOpen()
  const setModalIsOpen = updateDeliveryDateStore.useSetModalIsOpen()
  const setProposalId = updateDeliveryDateStore.useSetProposalId()

  const handleClick = () => {
    setModalIsOpen(true)
    setProposalId(order.proposalId)
  }

  return (
    <>
      <MenuItem onClick={handleClick} disableRipple disabled={disabled}>
        <LocalShippingIcon />
        Atualizar previsão de entrega
      </MenuItem>

      {isModalOpen && <UpdateDeliveryDateModal />}
    </>
  )
}
